export default __webpack_public_path__ + "static/logo-cn-30a9b3c1947c00b955d94fc5aa1875b8.svg";